// Where single-key shortcuts must not act: text fields, and embedded pages
// whose keys never reach this document.
import { composing } from './chord';

/** Controls that take typed text: a single-key shortcut there would type instead. Choices (radios, checkboxes) and buttons are not. */
const TEXT_ENTRY =
  'input:not([type=radio]):not([type=checkbox]):not([type=button]):not([type=submit]):not([type=reset]),textarea,select,[contenteditable]:not([contenteditable="false"]),[role="textbox"]';

/** Whether a key event's target takes typed text, so the page's single-key shortcuts leave it alone. */
export function isTextEntry(target: EventTarget | null): boolean {
  const el = target as Element | null;
  return typeof el?.closest === 'function' && el.closest(TEXT_ENTRY) !== null;
}

/**
 * Whether an embedded page (an iframe) has the focus. Its keys go to its own
 * document and never reach this one, so the page's shortcuts are paused until
 * the focus comes back, as it does on a click anywhere outside the frame.
 */
export function focusInFrame(doc: Document): boolean {
  return doc.activeElement?.tagName === 'IFRAME';
}

/**
 * Whether a key pressed in a text field asks to leave it: Esc that the field
 * (a menu, an edit it cancels) did not use, and that does not cancel an IME
 * candidate.
 */
export function leavesField(e: Pick<KeyboardEvent, 'key' | 'defaultPrevented' | 'isComposing'> & { keyCode?: number }): boolean {
  return e.key === 'Escape' && !e.defaultPrevented && !composing(e);
}
